import React, { forwardRef } from 'react';
import Type from 'prop-types';
import { Box } from "@mui/material";
import {
  CellMeasurer,
  CellMeasurerCache,
  List,
  AutoSizer,
} from 'react-virtualized';
import CascadeItem from '../CascadeItem';

const cache = new CellMeasurerCache({
  fixedWidth: true,
  defaultHeight: 200,
});

const CascadeList = forwardRef(function CascadeList(props, ref) {
  const { data, listHeight, onItemSelect } = props;
  const rowCount = data.length;

  const rowRenderer = (rowData) => {
    const { index, parent, key, style } = rowData;
    const item = data[index];

    return (
      <CellMeasurer
        cache={cache}
        columnIndex={0}
        key={key}
        parent={parent}
        rowIndex={index}
      >
        <div style={style}>
          <Box mb={2}>
            <CascadeItem data={item} onClick={onItemSelect} />
          </Box>
        </div>
      </CellMeasurer>
    );
  };

  return (
    <AutoSizer disableHeight>
      {({ width }) => (
        <List
          ref={ref}
          height={listHeight}
          overscanRowCount={10}
          rowCount={rowCount}
          deferredMeasurementCache={cache}
          rowHeight={cache.rowHeight}
          rowRenderer={rowRenderer}
          width={width}
        />
      )}
    </AutoSizer>
  );
});

CascadeList.propTypes = {
  data: Type.arrayOf(Type.shape(CascadeItem.propTypes.data)),
  listHeight: Type.number.isRequired,
  onItemSelect: Type.func.isRequired,
};

CascadeList.defaultProps = {
  data: [],
};

export default CascadeList;
